export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const API_SERVER_VERSION = 6;
export const DEFAULT_PROFILE_IMAGE_URL =
  //'https://s3.amazonaws.com/shyftassets/avatar1.png';
  '/icons/default-profile-thumb.svg';
